import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import EmailUser from "@/domain/entities/emails/EmailUser";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import SenderAvatar from "./SenderAvatar";

type RecipientsTooltipProps = {
    to: EmailUser[];
    cc: EmailUser[];
    bcc: EmailUser[];
    remainingCount: number;
    currentUserProfile?: any;
    className?: string;
};

const RecipientsTooltip = ({
    to,
    cc,
    bcc,
    remainingCount,
    currentUserProfile,
    className,
}: RecipientsTooltipProps) => {
    const { t } = useTranslation();

    const renderRecipientList = () => (
        <div className="flex flex-col gap-2 p-2 text-text-subtitle">
            {to.length > 0 && (
                <div>
                    <div className="mb-1 text-xs font-medium text-muted-foreground">
                        {t("email.to")}
                    </div>
                    <div className="flex flex-col gap-1">
                        {to.map((recipient) => (
                            <div key={recipient.email} className="text-sm">
                                {recipient.name} {`<${recipient.email}>`}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {cc.length > 0 && (
                <div>
                    <div className="mb-1 text-xs font-medium text-muted-foreground">
                        {t("email.cc")}
                    </div>
                    <div className="flex flex-col gap-1">
                        {cc.map((recipient) => (
                            <div key={recipient.email} className="text-sm">
                                {recipient.name} {`<${recipient.email}>`}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {bcc.length > 0 && (
                <div>
                    <div className="mb-1 text-xs font-medium text-muted-foreground">
                        {t("email.cci")}
                    </div>
                    <div className="flex flex-col gap-1">
                        {bcc.map((recipient) => (
                            <div key={recipient.email} className="text-sm">
                                {recipient.name} {`<${recipient.email}>`}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <TooltipProvider delayDuration={100}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className={cn(
                            "inline-flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0",
                            className,
                        )}
                        type="button"
                    >
                        <SenderAvatar
                            currentUserProfile={currentUserProfile}
                            showTooltip={false}
                            text={`+${remainingCount}`}
                        />
                    </button>
                </TooltipTrigger>
                <TooltipContent
                    align="center"
                    className="border bg-white"
                    side="bottom"
                >
                    {renderRecipientList()}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default RecipientsTooltip;
